import styled, { css } from "styled-components";
import Button from "ui/Button";

export const Container = styled.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  min-width: 150px;
  width: 100%;
  height: 40px;
`;

export const Icon = styled.span`
  display: flex;
  width: 36px;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme?.colors?.primary.surface};
  border: 1.5px solid ${({ theme }) => theme?.colors?.neutral.neutral30};
  border-right: none;
  border-radius: 8px 0 0 8px;
  box-sizing: border-box;
`;

export const CopyText = styled.input<{ disabled?: boolean }>`
  margin: 0;
  padding: 8px 15px 8px 8px;
  border: 1.5px solid ${({ theme }) => theme?.colors?.neutral.neutral30};
  border-right: none;
  border-radius: 8px 0 0 8px;
  width: 100%;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  caret-color: transparent;
  color: ${({ theme }) => theme?.colors?.neutral.neutral70};
  background-color: ${({ disabled, theme }) =>
    disabled ? theme?.colors?.neutral.neutral30 : theme?.colors?.neutral.neutral10};

  &:focus {
    outline: none;
  }
`;

export const CopyButton = styled(Button)<{ disabled?: boolean }>`
  padding: 16px;
  width: fit-content;
  height: 100%;
  border-radius: 0 8px 8px 0;
  background-color: ${({ disabled, theme }) =>
    disabled ? theme?.colors?.neutral.neutral60 : theme?.colors?.primary.default};
  position: relative;

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        cursor: pointer;
        background-color: ${({ theme }) => theme?.colors?.primary.default};

        :after {
          content: attr(aria-label);
          position: absolute;
          background-color: ${({ theme }) => theme?.colors?.neutral.neutral90};
          color: white;
          padding: 5px 10px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 400;
          top: 100%;
          left: 50%;
          white-space: nowrap;
          transform: translateX(-50%);
          margin-top: 5px;
        }
      }
    `}
`;
